export const SET_OAUTH_PROVIDER = "SET_OAUTH_PROVIDER"
export const CLEAR_OAUTH_PROVIDER = "CLEAR_OAUTH_PROVIDER"
export const HANDLE_OAUTH_STATE_ERROR_CALL = "HANDLE_OAUTH_STATE_ERROR_CALL"
export const HANDLE_OAUTH_STATE_NOT_SUPPORT_CALL =
  "HANDLE_OAUTH_STATE_NOT_SUPPORT_CALL"
